function createBreadcrumbList(breadcrumbs, template = null) {
    const handles = ['special-collections'];
    const breadcrumbItems = [];
    breadcrumbs.forEach((breadcrumb, index) => {
        const generate_separator = renderSeparator();
        const listItem = document.createElement("li");
        listItem.classList.add("breadcrumb-item", "updated_by_api");
        const link = document.createElement("a");
        // inserting active class based on the template
        (index == breadcrumbs.length - 1) ? (template === 'collection' ? link.classList.add('breadcrumbs-link', 'active') : link.classList.add('breadcrumbs-link')) : link.classList.add('breadcrumbs-link');

        const title = handles.includes(breadcrumb.handle) ? 'Collections' : breadcrumb.title;

        link.setAttribute("title", title);
        link.textContent = title;
        listItem.appendChild(link);

        // adding separator to the starting of every breadcrumb item
        if (index < breadcrumbs.length) {
            listItem.prepend(generate_separator);
        }

        breadcrumbItems.push(listItem);
    });
    return breadcrumbItems;
}

function renderSeparator() {
    const separator = document.createElement("span");
    separator.classList.add("breadcrumb-separator");
    separator.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_4_13473)">
        <path d="M9.29006 6.71002C8.90006 7.10002 8.90006 7.73002 9.29006 8.12002L13.1701 12L9.29006 15.88C8.90006 16.27 8.90006 16.9 9.29006 17.29C9.68006 17.68 10.3101 17.68 10.7001 17.29L15.2901 12.7C15.6801 12.31 15.6801 11.68 15.2901 11.29L10.7001 6.70002C10.3201 6.32002 9.68006 6.32002 9.29006 6.71002Z" fill="#18334F"/>
        </g>
        <defs>
        <clipPath id="clip0_4_13473">
        <rect width="24" height="24" fill="white"/>
        </clipPath>
        </defs>
        </svg>`;

    return separator;
}

function renderBreadcrumb(breadcrumbs, template) {
    const breadcrumbList = createBreadcrumbList(breadcrumbs, template);
    const breadcrumbContainer = document.querySelector("nav.breadcrumb ul");
    const firstListItem = breadcrumbContainer.querySelector("li.home_default");

    breadcrumbList.reverse();
    breadcrumbList.forEach((listItem) => {
        breadcrumbContainer.insertBefore(listItem, firstListItem.nextSibling);
    });
}

async function renderSubcategories(subcategories) {
    class ShowSubCategories extends HTMLElement {
        constructor() {
            super();
            this.renderSubcategories(subcategories);
        }
        async renderSubcategories(subcategories) {
            const container = this.querySelector(".sub_categories");
            const see_more = this.querySelector("#seeMoreBtn");
            const categoriesToShow = 12; // counting starts from 0;
            const total_subcategories = subcategories.length;
            const restricted = await window.globalApi.isCountryRestricted();
            const canBypass = localStorage.getItem('bypass') || false;

            for (let i = 0; i < subcategories.length; i++) {
                const subcategory = subcategories[i];
                const isGTRcat = containsGTRCategorySentences(subcategory.title) ? true : false;
                if (restricted && isGTRcat && (canBypass == 'false')) continue;
                const item = document.createElement("div");
                item.classList.add("grid__item", "subcollection", "updated_by_api");

                const link = document.createElement("a");
                link.classList.add("subcollection-link");
                link.textContent = subcategory.title;

                item.appendChild(link);
                container.appendChild(item);
            };

            this.classList.remove("hidden");

            // showing see more button if subcategories are more than 12;
            (total_subcategories > categoriesToShow) ? see_more.classList.remove("hidden") : '';

            let showMore = true; // Initially, we're showing all
            const all_subcollections = this.querySelectorAll(".sub_categories .subcollection");

            if (window.innerWidth < 768) {
                // remove hidden class from the all subcategories
                all_subcollections.forEach((subcategory) => {
                    subcategory.classList.remove("hidden");
                });
            } else {
                see_more.addEventListener("click", function () {
                    showMore = !showMore; // Toggle the showMore flag
                    // Show/hide the div elements based on the categoriesToShow
                    for (let i = categoriesToShow + 1; i < total_subcategories; i++) {
                        console.log(all_subcollections[i], i);
                        showMore ? all_subcollections[i].classList.remove("hidden") : all_subcollections[i].classList.add("hidden");
                    }

                    if (showMore) {
                        see_more.querySelector('span').innerHTML = "See Less";
                        see_more.classList.add("active");
                    } else {
                        see_more.querySelector('span').innerHTML = "See More";
                        see_more.classList.remove("active");
                    }
                });
            }
        }
    }

    customElements.define("show-subcategories", ShowSubCategories);
}

function updateLinksFromAPI(links, elementClass, validTypes) {
    const urlParams = new URLSearchParams(window.location.search);
    const gfValue = urlParams.get("gf_67328");
    links.forEach((link, index) => { // links = fetched subcategories.
        const url = document.querySelectorAll(`a.${elementClass}`)[index];
        if (!url) return;
        url.href = `https://${window.Shopify.shop}/collections/${link.handle}`;
        if (validTypes.includes(gfValue) || validTypes.includes(encodeURIComponent(gfValue))) {
            url.href += `/?gf_67328=${encodeURIComponent(gfValue)}`;
        }
    });
}

async function fetchCategoryDetails(collectionID, template) {
    try {
        const response = await window.customerApi.getCategoryDetails(collectionID);
        const data = await response.json();
        const types = ['type:buy-now', 'type:archive', 'type:buy_now', 'type:Buy Now', 'type:Archive']; // these tags are updated from the client spreadsheet.

        if (window.customerVerificationData == undefined || !window.customerVerificationData) await get_is_verified();

        if (!data?.data) { // if no data received from the api
            // don't show it only for the product template
            if (template == 'product') return;
            window.showToast("error", {
                title: "No data received",
                message: "Please reload the page.",
            });
            return;
        }

        const { breadcrumbs, subcategories, title } = data.data;

        // updating Title of the collection page.
        const collection_element = document.querySelector('h1.collection-hero-title');
        if (collection_element) {
            collection_element.textContent = title;
            collection_element.classList.add('updated_by_api');
        }

        if (breadcrumbs?.length) {
            renderBreadcrumb(breadcrumbs, template);
            updateLinksFromAPI(breadcrumbs, 'breadcrumbs-link', types);
        }
        if (subcategories?.length) {
            await renderSubcategories(subcategories);
            updateLinksFromAPI(subcategories, 'subcollection-link', types);
        }
    } catch (error) {
        console.log('CATEGORY error', error);
    }
}

const collectionID = document.querySelector('main').dataset.collectionId;
const template = document.querySelector('main').dataset.template;
if (collectionID) {
    console.log('collectionID', collectionID);
    fetchCategoryDetails(collectionID, template);
    // fetchAllAuctions();
}